import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
import { interpret } from "xstate";
import simplebar from "simplebar-vue";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import ReviewFormDetail from "./ReviewFormDetail.vue";
import ReviewTracker from "./ReviewTracker.vue";
import TakeActions from "./TakeActions.vue";
import SkeletonLoaderReview from "@/components/SkeletonLoaderReview.vue";
import { toaster } from "@/utilities/toaster";
import paReviewMachine from "../machines/reviewMachine";
import { PAReviewModule } from "@/store/modules/paReview.module";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Swal from "sweetalert2";
import ReviewMeeting from "./ReviewMeeting.vue";
let ReviewComponent = /** @class */ (() => {
    let ReviewComponent = class ReviewComponent extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.selectedReviewFormStep = null;
            //   MACHINE
            this.machine = paReviewMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
            this.isNonInteractive = false;
            this.openedByClient = false;
            this.isMeetingSelected = false;
        }
        send(event) {
            this.machineService.send(event);
        }
        selectReviewFormStep(reviewFormStep) {
            var data = this.ValidateChangesForNextStep();
            if (data) {
                toaster.ShowError("You have some unsaved changes.");
            }
            else {
                this.selectedReviewFormStep = reviewFormStep;
            }
        }
        ValidateChangesForNextStep() {
            var reviewFormDetail = this.$refs["stepComponent"];
            var qna = reviewFormDetail.$children.find((x) => x.$children);
            var isAnyAnswerDirty = qna.$children.some((element) => {
                return element.isAnswerDirty;
            });
            var isAnyCommentDirty = qna.$children.some((reviewDetailComponent) => {
                return reviewDetailComponent.$children.some((questionAndAnswerComponent) => {
                    return questionAndAnswerComponent.isCommentDirty;
                });
            });
            return isAnyAnswerDirty || isAnyCommentDirty;
        }
        goToReviewTracker() {
            var data = this.ValidateChangesForNextStep();
            if (data) {
                toaster.ShowError("You have some unsaved changes.");
            }
            else {
                this.send({ type: "ENTER_TRACKER" });
            }
        }
        closeReviewTracker() {
            this.send({ type: "EXIT_TRACKER" });
        }
        closeReviewModal() {
            if (this.state.matches("modalActive.loadedReview.reviewTracker")) {
                this.ConfirmAction();
            }
            else {
                var data = this.ValidateChangesForNextStep();
                if (data) {
                    this.checkForAction();
                }
                else {
                    this.ConfirmAction();
                }
            }
        }
        ConfirmAction() {
            this.send({ type: "MAKE_MODAL_DORMANT" });
            this.selectedReviewFormStep = null;
            this.$bvModal.hide("performance-review");
            this.$emit("modalClosed");
        }
        checkForAction() {
            Swal.fire({
                customClass: {
                    container: "remove-swal2-container",
                    title: "remove-swal2-title",
                    popup: "remove-swal2-popup",
                    icon: "remove-swal2-icon",
                },
                text: `You won't be able to revert this!`,
                icon: "warning",
                title: "Are you sure you want to close the page without saving the changes?",
                showCancelButton: true,
                confirmButtonColor: "#f46a6a",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes",
                cancelButtonText: "No",
            }).then((result) => {
                if (result.value) {
                    return this.ConfirmAction();
                }
                return false;
            });
        }
        ShowReviewModal(reviewId, currentStepId, openedByClient = false) {
            this.openedByClient = openedByClient;
            this.send({ type: "GETTING_REVIEWS", reviewId: reviewId, stepId: currentStepId, openedByClient: openedByClient });
            this.$bvModal.show("performance-review");
        }
        ShowNonInteractiveReviewModal(reviewId, isMeetingSelected) {
            this.isNonInteractive = true;
            this.isMeetingSelected = isMeetingSelected;
            this.send({ type: "GETTING_REVIEW_FOR_DISPLAY", reviewId: reviewId });
            this.$bvModal.show("performance-review");
        }
        ShowReviewModalFromExecutor(reviewId, currentStepId, isMeetingSelected = false) {
            this.isMeetingSelected = isMeetingSelected;
            this.ShowReviewModal(reviewId, currentStepId, false);
        }
        processAction(action, reject) {
            if (action == "promote" && this.validatePromote()) {
                return;
            }
            this.send({ type: "PROCESS_ACTION", actionName: action, rejectReason: reject });
        }
        validatePromote() {
            if (this.reviewDetail) {
                const invalidForm = this.reviewDetail.reviewFormDetails.find((x) => x.questionAndAnswerItems.some((y) => y.isMandatory && !y.answerText));
                if (invalidForm) {
                    toaster.ShowError("Please write answers for the mandatory questions.");
                    this.selectedReviewFormStep = invalidForm;
                    return true;
                }
            }
            return false;
        }
        goToReview(reviewId) {
            if (this.isNonInteractive) {
                this.send({ type: "GETTING_REVIEW_FOR_DISPLAY", reviewId: reviewId });
            }
            else {
                this.send({ type: "GETTING_REVIEWS", reviewId: reviewId, stepId: this.state.context.stepId, openedByClient: this.state.context.openedByClient });
            }
            this.selectedReviewFormStep = null;
        }
        get nextSection() {
            if (this.reviewDetail && this.selectedReviewFormStep) {
                var index = this.reviewDetail.reviewFormDetails.findIndex((x) => x.uniqueSectionId == this.selectedReviewFormStep.uniqueSectionId);
                if (index >= 0 && index + 1 < this.reviewDetail.reviewFormDetails.length) {
                    return this.reviewDetail.reviewFormDetails[index + 1];
                }
            }
            return null;
        }
        get previousSection() {
            if (this.reviewDetail && this.selectedReviewFormStep) {
                var index = this.reviewDetail.reviewFormDetails.findIndex((x) => x.uniqueSectionId == this.selectedReviewFormStep.uniqueSectionId);
                if (index >= 0 && index - 1 >= 0) {
                    return this.reviewDetail.reviewFormDetails[index - 1];
                }
            }
            return null;
        }
        get reviewDetail() {
            return PAReviewModule.reviewDetail;
        }
        get stepReview() {
            return this.reviewDetail.reviewFormDetails;
        }
        get stepComponentName() {
            if (this.selectedReviewFormStep) {
                return this.selectedReviewFormStep.componentName;
            }
            return null;
        }
        get showLoader() {
            return this.state.hasTag("gettingReview");
        }
        get pdfDownload() {
            return PAReviewModule.pdfData;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
                console.log(this.state.toStrings());
                if (this.state.matches("modalActive.loadedReview")) {
                    if (this.selectedReviewFormStep == null) {
                        if (!this.isMeetingSelected) {
                            this.selectedReviewFormStep = this.reviewDetail.reviewFormDetails[0];
                        }
                        else {
                            this.selectedReviewFormStep = this.reviewDetail.reviewFormDetails.find((f) => f.componentName == "ReviewMeeting");
                        }
                    }
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    ReviewComponent = __decorate([
        Component({
            name: "ReviewComponent",
            components: {
                Loader,
                SkeletonLoaderReview,
                simplebar,
                TakeActions,
                ReviewFormDetail,
                ReviewTracker,
                SectionLoader,
                ReviewMeeting,
            },
        })
    ], ReviewComponent);
    return ReviewComponent;
})();
export default ReviewComponent;
